/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

/**
 * Core scripts.
 */
import AppHandler from '~/core/app-handler'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import Query from '~/core/query'
import { domReady } from '~/core/runners'
import '~/core/bugsnag'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query) => Query(query)

/**
 * DOM ready.
 */
domReady(() => {
  Commands().init()

  AppHandler().beforeVueInit()
  Canvas().init()
  AppHandler().afterVueInit()
})
